import { useEffect, useState } from 'react';
import StatusService from 'views/status/service';

export const useStatuses = (selectedRecordType, isModalOpen) => {
  const [statuses, setStatuses] = useState([]);

  useEffect(() => {
    if (!isModalOpen || !selectedRecordType) {
      setStatuses([]);
      return;
    }

    const fetchStatuses = async () => {
      try {
        const response = await StatusService.getByRecordType(
          Number(selectedRecordType)
        );
        setStatuses(response?.data?.content ?? []);
      } catch (error) {
        console.error('Erro ao buscar status:', error);
        setStatuses([]);
      }
    };

    fetchStatuses();
  }, [isModalOpen, selectedRecordType]);

  return { statuses };
};
